// Lib
import React from 'react';
import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';

// Components
import InlineBoardLinkInitialContent from './InlineBoardLinkInitialContent';

// Constants
import { InlineBoardLinkOptions, InlineBoardLinkStatus } from './inlineBoardLinkConstants';

const SimpleInlineBoardLinkContent = () => <span />;

const InlineBoardLinkContentSwitch = (props: NodeViewProps) => {
    const { node, extension } = props;
    const { status } = node.attrs;
    const { NodeViewResolvedContent = SimpleInlineBoardLinkContent } = extension.options as InlineBoardLinkOptions;

    switch (status) {
        case InlineBoardLinkStatus.initial:
            return <InlineBoardLinkInitialContent {...props} />;
        case InlineBoardLinkStatus.resolved:
            return <NodeViewResolvedContent {...props} />;
        default:
            return null;
    }
};

const InlineBoardLinkNodeView = (props: NodeViewProps) => (
    <NodeViewWrapper as="span" className="inline-board-link">
        <InlineBoardLinkContentSwitch {...props} />
    </NodeViewWrapper>
);

export default InlineBoardLinkNodeView;
